// extracted by mini-css-extract-plugin
export default {"webspace-section":"webspace-section--mBTWXDJq48","webspaceSection":"webspace-section--mBTWXDJq48"};